module.exports = __webpack_public_path__ + "assets/favicon.53da1960da1b591bec926a3d465e4b53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/logo/favicon.png
// module id = 442
// module chunks = 1